module.exports = __webpack_public_path__ + "assets/img/activity-time-5ce93d93.png";